import { render, staticRenderFns } from "./standardTaskAdd.vue?vue&type=template&id=0f19dae3&scoped=true&"
import script from "./standardTaskAdd.vue?vue&type=script&lang=js&"
export * from "./standardTaskAdd.vue?vue&type=script&lang=js&"
import style0 from "./standardTaskAdd.vue?vue&type=style&index=0&id=0f19dae3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19dae3",
  null
  
)

export default component.exports